<template>
  <base-table-box>
    <base-table
      class="custom-table"
      :columns="columns"
      :dataSource="tableData"
      :pagination="page"
      :rowKey="record => record.mienId"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="mediaUrl" slot-scope="record">
<!--        <img :src="" alt="">-->
        <picture-card isPreview v-if="record.mediaType === '1' && record.mediaUrl" :fileList="record.mediaUrl.split(',')"/>
      </template>
      <template #content="content">
        <a-tooltip :title="content">
          <div class="table-ellipsis">
            {{content}}
          </div>
        </a-tooltip>
      </template>
      <template #operation="record">
        <a href="javascript: void 0;" class="text-btn" @click="delRecord(record)">删除</a>
      </template>
    </base-table>
  </base-table-box>
</template>

<script>
import { company } from '@/api'
export default {
  name: 'CompanyHonor',
  beforeCreate () {
    this.columns = [
      {
        title: '标题',
        dataIndex: 'titleName'
      },
      {
        title: '封面',
        width: 112,
        scopedSlots: {
          customRender: 'mediaUrl'
        }
      },
      {
        title: '简介',
        dataIndex: 'content',
        scopedSlots: {
          customRender: 'content'
        }
      },
      {
        title: '操作',
        scopedSlots: {
          customRender: 'operation'
        }
      }
    ]
  },
  async mounted () {
    if (this.$route.params.id) {
      this.companyId = this.$route.params.id
    }
    await this.getTableData()
  },

  data () {
    return {
      imageUrl: process.env.VUE_APP_IMG,
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      companyId: ''
    }
  },

  methods: {
    async getTableData () {
      this.loading = true
      let { code, msg, data, page } = await company.getCompanyHonorPage({
        companyId: this.companyId,
        type: '2',
        ...this.page
      })
      this.tableData = data
      this.loading = false
      if (code !== 0) return this.$message.error(msg || '数据获取失败')
      this.page.total = page.total
    },
    handleScreenSubmit () {
      this.page.current = 1
      this.getTableData()
    },
    handleReset () {
      this.screenForm.resetFields()
      this.page.current = 1
      this.getTableData()
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableData()
    },
    delRecord ({ mienId }) {
      this.$confirm({
        title: '提示',
        content: '您确定要删除该经典案例信息吗?',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let { code, msg } = await company.deleteCompanyHonor({
            mienId
          })
          if (code === 0) {
            this.$message.success('删除成功')
            this.getTableData()
          } else {
            this.$message.error(msg || '删除失败，请重试')
          }
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table_name_info {
  display: flex;
  align-items: center;
  .table_name_img {
    flex: none;
    width: 60px;
    height: 60px;
    margin: 0px 12px 10px 0;
  }
}
</style>
